import { Injectable } from '@angular/core';

import { add, differenceInDays } from 'date-fns';

import { DateForSlider } from '@paymash/sdk/models/frontend/date-for-slider';
import { reformatDateUtils } from '@modules/core/utils';

@Injectable()
export class DateCalendarService {
  public generateDateList(selectedDate: string): Array<DateForSlider> {
    const days: Array<DateForSlider> = [];
    let dateStart = new Date(selectedDate);
    const dateEnd = add(new Date(selectedDate), {
      days: 56,
    });

    while (differenceInDays(dateEnd, dateStart) > 0) {
      days.push(this.createDateItem(dateStart));
      dateStart = add(dateStart, {
        days: 1,
      });
    }

    return days;
  }

  private createDateItem(date: Date): DateForSlider {
    const stringDate = reformatDateUtils(date);

    return {
      date: stringDate,
      selected: false,
      available: true,
    };
  }
}
